import { useMap } from '~map-preview/states/map'
import { getEmbedMapLink } from 'utils'

export const useMapEmbedLink = () => {
  const mapData = useMap()
  return mapData.isPublic || mapData.embedKey
    ? getEmbedMapLink(mapData)
    : undefined
}
